export default __webpack_public_path__ + "static/media/slide7.efd61a9f.webp";